import React from 'react';
import { useTranslation } from 'react-i18next'; // Import kuke za prevod
import Icon from '../AppIcon';

const ModalSuperAdmin = ({ company, onClose }) => {
  const { t, i18n } = useTranslation(); // t funkcija za ključeve

  if (!company) return null;

  // Formatiranje datuma na osnovu trenutnog jezika
  const formatDateTime = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    
    // Automatski koristi format prema jeziku (npr. 'en-US', 'bs-BA', itd.)
    const locale = i18n.language === 'bs' ? 'bs-BA' : 
                   i18n.language === 'it' ? 'it-IT' : 
                   i18n.language === 'de' ? 'de-DE' : 'en-US';

    return date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card w-full max-w-md rounded-2xl shadow-2xl border border-border overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="p-6 border-b border-border bg-muted/20 flex justify-between items-start">
          <div>
            <h3 className="text-xl font-bold text-foreground leading-tight">{company.nome_azienda}</h3>
            <p className="text-[10px] text-primary uppercase font-black tracking-[0.2em] mt-1">
              {t('company_modal.header_subtitle')}
            </p>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-muted rounded-full text-muted-foreground transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          
          {/* Adresa */}
          <div className="p-4 rounded-xl bg-primary/5 border border-primary/10 flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
              <Icon name="MapPin" size={20} />
            </div>
            <div>
              <span className="text-[9px] font-black uppercase text-primary tracking-widest block">
                {t('company_modal.address_label')}
              </span>
              <p className="text-sm font-bold text-foreground">
                {company.indirizzo || t('common.not_available')}
              </p>
            </div>
          </div>

          {/* Registrovan */}
          <div className="p-4 rounded-xl bg-primary/5 border border-primary/10 flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
              <Icon name="Calendar" size={20} />
            </div>
            <div>
              <span className="text-[9px] font-black uppercase text-primary tracking-widest block">
                {t('company_modal.registered_label')}
              </span>
              <p className="text-sm font-bold text-foreground">{formatDateTime(company.creato_il)}</p>
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="p-4 bg-muted/20 border-t border-border">
          <button 
            onClick={onClose} 
            className="w-full py-3.5 bg-primary text-primary-foreground rounded-xl font-black text-[10px] uppercase tracking-[0.2em] hover:opacity-90 transition-all shadow-lg shadow-primary/20"
          >
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalSuperAdmin;